import axios from 'axios';
import config from '../config';
import { showError } from '../utils';

// Generic network call function (copied from consultation.js pattern if not exported commonly, 
// strictly speaking it seems networkCall is internal to consultation.js, so I'll implement a simple one or see if I can reuse)
// Looking at consultation.js, networkCall is local. I will implement a similar one here or just use axios directly for now with proper error handling.

function networkCall({ method, url, headers, params, data }) {
    return axios({
        method,
        url,
        headers,
        params,
        data,
    })
        .then((resp) => {
            const responseBody = resp.data;
            if (responseBody.message === 'success' || responseBody.success) {
                return responseBody;
            } else {
                const error = new Error('Invalid response');
                error.data = responseBody;
                throw error;
            }
        })
        .catch((err) => {
            console.error(err);
            throw err;
        });
}

export function getLandingPageData(centerId) {
    // No auth token needed for this public API apparently? 
    // The previous implementation utilized fetch without headers. 
    // However, usually we might want to pass it if available.
    // The url was: https://api.getvisitapp.net/stoker/opd/scanAndPay/landige-page-data?centerId=${centerId}

    // ...existing code...
    return networkCall({
        method: 'get',
        url: `${config.apiBaseUrl}/opd/scanAndPay/landige-page-data`,
        params: { centerId },
    });
}

export function fetchCenterLogos(hexCode) {
    const params = {};
    if (hexCode) params.hexCode = hexCode;

    return networkCall({
        method: 'post',
        url: `${config.apiBaseUrl}/landing-page/fetch-center-logos`,
        params,
    });
}
